module.exports = __webpack_public_path__ + "img/个人管理.178fc108.svg";